// Frontend analytics wire types. Fields are snake_case to match the Go/proto backend.
// HIPAA: only opaque IDs, enum-like names, and non-PHI context ever appear here.

export const AnalyticsEventType = {
  PAGE_VIEW: 1,
  CLICK: 2,
  INPUT: 3,
  CHANGE: 4,
  ERROR: 5,
} as const;

export interface AppEventPayload {
  event_id: string;
  event_time: number; // client epoch ms
  event_type: number;
  event_name: string;
  org_id: string;
  program_id?: string;
  route_pattern?: string;
  case_record_id?: string;
  target_id?: string;
  url_path?: string;
  props?: Record<string, string>;
}

interface AppInfo {
  name: string;
  version: string;
}

interface DeviceInfo {
  browser: string;
  os: string;
}

interface SessionInfo {
  id: string;
}

export interface AppEventsBatch {
  app: AppInfo;
  device: DeviceInfo;
  session: SessionInfo;
  events: AppEventPayload[];
}

export interface TrackContext {
  programId?: string;
  routePattern?: string;
  caseRecordId?: string;
  targetId?: string;
  props?: Record<string, string>;
}
